export function getServiceWorkerVersion(): Promise<string | null> {
    return new Promise((resolve) => {
        if (!navigator.serviceWorker.controller) {
            return resolve(null)
        }

        const channel = new MessageChannel();

        channel.port1.onmessage = (event) => {
            if (event.data?.type === "VERSION") {
                resolve(event.data.version);
            }
        };

        navigator.serviceWorker.controller.postMessage({type: "GET_VERSION"}, [channel.port2]);
    });
}